import { Box, Grid, Hidden } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import CustomizedAccordion from 'components/CustomizedAccordion';
import VerticalTabs from 'components/VerticalTabs';
import messages from 'containers/AsiDetailsPage/MyContractAndGarantiesTab/MyHealthCoverage/messages';
import {
  ColoredDivider,
  SizedSmallSectionHeader,
} from 'containers/AsiDetailsPage/MyContractAndGarantiesTab/MyHealthCoverage/style';
import {
  AccordionDetailsCaptions,
  ItemWrapper,
  StyledCaptions,
} from 'containers/MRHDetailsPage/PreventionGuide/styles';
import { isReverse, translate } from 'helpers/intl';
import { get } from 'lodash';
import { sanlamBlue, sanlamVeryDarkBlue } from 'Material-UI/colors';
import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

const ResponsiveCoverages = (props: any) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const [expanded, setExpanded] = useState<boolean | number>(false);

  const handleChange = (index: number) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean,
  ) => {
    /* istanbul ignore next */
    setExpanded(isExpanded ? index : false);
  };
  return (
    <>
      <Hidden xsDown>
        <VerticalTabs items={props.items} />
      </Hidden>
      <Hidden smUp>
        <Grid spacing={1} direction="column" container>
          {props.items.map((item: any, index: number) => (
            <Grid key={index} item xs>
              <CustomizedAccordion
                expanded={expanded === index}
                changeHandler={handleChange(index)}
                summary={
                  <ItemWrapper reverse={reverse}>
                    <StyledCaptions
                      weight="500"
                      color={
                        index === expanded ? sanlamBlue : sanlamVeryDarkBlue
                      }
                    >
                      {item.title}
                    </StyledCaptions>
                  </ItemWrapper>
                }
                details={
                  <Box paddingX={3}>
                    <AccordionDetailsCaptions weight="400">
                      {item.description}
                    </AccordionDetailsCaptions>
                  </Box>
                }
              />
            </Grid>
          ))}
        </Grid>
      </Hidden>
    </>
  );
};

const MyHealthCoverageBloc: React.FC<{
  intl: IntlShape;
  coverages: any[];
  isLoadingDetailContract: boolean;
}> = (props) => {
  return (
    <>
      {props.coverages && (
        <>
          <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
            {translate(messages.MyComplementaryHealthCoverageTitle, props)}
            {`(${get(props, 'coverages.length', '0')})`}
          </SizedSmallSectionHeader>
          {props.isLoadingDetailContract ? (
            <Skeleton
              data-testid="loader"
              variant="rect"
              width={767}
              height={154}
            />
          ) : (
            <ResponsiveCoverages items={props.coverages} />
          )}
          <ColoredDivider orientation="horizontal" />
        </>
      )}
    </>
  );
};

export default injectIntl(MyHealthCoverageBloc);
